<!-- 
      ___       ___           ___     
     /\__\     /\__\         /\  \    
    /:/  /    /::|  |       /::\  \   
   /:/  /    /:|:|  |      /:/\ \  \  
  /:/  /    /:/|:|__|__   _\:\~\ \  \ 
 /:/__/    /:/ |::::\__\ /\ \:\ \ \__\
 \:\  \    \/__/~~/:/  / \:\ \:\ \/__/
  \:\  \         /:/  /   \:\ \:\__\  
   \:\  \       /:/  /     \:\/:/  /  
    \:\__\     /:/  /       \::/  /   
     \/__/     \/__/         \/__/

LARRY MANAGEMENT SYSTEM V1.0
-->

<template>
  <div class="timesheet-body">
    <div>
      <!-- <div v-if="errorMessage">
        <h3 class="errorMessage">
          {{ errorMessage }}
        </h3>
      </div> -->

      <b-modal
          v-model="showEventCreationDialog"
          id="myModal"
          hide-backdrop
          centered
          title="Create Task"
          @ok="handleOk"
          @hidden="resetModal"
          @cancel="resetModal"
      >
        <b-form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
              :state="tenantState"
              label="Tenant"
              label-for="tenant-input"
              invalid-feedback="Please select a customer."
          >
            <b-form-select
                id="tenant-input"
                v-model="selectedEvent.tenant"
                @change="handleTasks"
                :options="tenantNames"
                value-field="value"
                text-field="name"
                :state="tenantState"
                required
            ></b-form-select>
          </b-form-group>
          <b-form-group
              label="Task:"
              label-for="task-input"
              invalid-feedback="Please select a task type."
          >
            <b-form-select
                id="task-input"
                v-model="selectedEvent.task"
                :options="tasks"
                required
                changed
                :state="taskState"
            ></b-form-select>
          </b-form-group>

          <b-form-group
              label="Description"
              label-for="notes-input"
              invalid-feedback="Please enter a description."
          >
            <b-form-input
                id="notes-input"
                v-model="selectedEvent.title"
                placeholder="Description"
                required
                changed
                :state="noteState"
            ></b-form-input>
          </b-form-group>
        </b-form>
      </b-modal>

      <b-modal
          id="changeModal"
          hide-backdrop
          centered
          title="Edit Task"
          @ok="changeOk"
          @hidden="changeModal"
          @cancel="changeModal"
      >
        <b-form ref="changeForm" @submit.stop.prevent="changeSubmit">
          <b-form-group
              :state="tenantState"
              label="Tenant"
              label-for="tenant-change-input"
              invalid-feedback="Please select a customer."
          >
            <b-form-select
                id="tenant-change-input"
                v-model="changeEvent.tenant"
                :options="tenantNames"
                value-field="value"
                text-field="name"
                :state="tenantState"
                required
            ></b-form-select>
          </b-form-group>
          <transition name="fade">
            <b-form-group
                label="Task:"
                label-for="task-change-input"
                invalid-feedback="Please select a task type."
            >
              <b-form-select
                  id="task-change-input"
                  :value="changeEvent.task"
                  v-model="changeEvent.task"
                  @change="handleTasks"
                  :options="tasks"
                  required
                  :state="taskState"
              ></b-form-select>
            </b-form-group>
          </transition>

          <b-form-group
              label="Description"
              label-for="notes-change-input"
              invalid-feedback="Please enter a description."
          >
            <b-form-input
                id="notes-change-input"
                v-model="changeEvent.title"
                @change="changeTitle"
                required
                :state="noteState"
            ></b-form-input>
          </b-form-group>
        </b-form>
      </b-modal>
    </div>
    <div class="cal-container">
      <div class="row">
        <div class="bigtext">Time Tracker for {{ $auth.user.name }} : <br/></div>
        <Datepicker
            v-if="showDateRangeAndUserDropdown()"
            v-model="range"
            type="week"
            range-separator=" - "
            placeholder="Date Range"
            style="margin-left: 10px; width: 250px; margin-top: 5px;"
            @change="onDateChange()"
        >
        </Datepicker>
        <div
            class="dropdown col p-0"
            v-if="showDateRangeAndUserDropdown()"
        >
          <select
              style="background: #1dd8f6; color: #fff;  border: 0; margin-left: 10px; margin-bottom: 10px; padding: 8px;"
              id="tenantId"
              v-model="lastSelectedTenant"
              @change="onDateChange()"
          >
            <option
                class="tenantOption"
                v-for="option in tenantsDropdown"
                v-bind:key="option"
                :value="option.userId"
            >{{ option.name_first + " " + option.name_last }}
            </option>
          </select>
        </div>
      </div>
      <div class="spacebelow">
        Drag on the calendar below to enter your daily tasks! <br/>
        Double click to edit a task! <br/>
      </div>

      <vue-cal
          ref="vuecal"
          class="vuecal--blue-theme"
          :time-from="5 * 60"
          :time-to="23 * 60"
          hide-view-selector
          :disable-views="['years', 'year', 'month', 'day']"
          :editable-events="{
          resize: true,
          create: true,
        }"
          active-view="week"
          startWeekOnSunday
          :snap-to-time="15"
          :drag-to-create-threshold="30"
          :on-event-create="onEventCreate"
          :on-event-dblclick="onEventClick"
          @event-drag-create="showEventCreationDialog = true"
          @event-duration-change="changeEventDuration"
      >
      </vue-cal>
      <br/>
      <b-button class="export-btn" v-on:click="generateCSV" pill variant="info"
      >Export As CSV
      </b-button>
    </div>
  </div>
</template>

<script>
// PROD "clientId": "yZDDVs2TTrmosT7dgaANjjP4VwMKxmH4"
import VueCal from "vue-cal";
import "../assets/vuecal.css";
import Datepicker from "vue2-datepicker";
import 'vue2-datepicker/index.css';
// import { id } from "date-fns/locale";

const {startOfWeek, endOfWeek, addDays, subDays} = require("date-fns");

export default {
  computed: {
    tenantNames: function () {
      return this.tenants.map((el) => {
        return {
          name: el.text,
          value: el.value
        }
      });
    },
  },
  created() {
    this.fetchData();
    this.fetchUserTasks();
  },

  name: "Timesheet",
  components: {VueCal, Datepicker},
  data() {
    const now = new Date();
    const minDate = addDays(startOfWeek(now), 1);
    const maxDate = subDays(endOfWeek(now), 1);
    return {
      errorMessage: undefined,
      tenantState: null,
      taskState: null,
      noteState: null,
      selectedEvent: {
        db_id: null,
        title: null,
        tenant: null,
        task: null,
      },
      changeEvent: {
        db_id: null,
        title: null,
        tenant: null,
        task: null,
        start: null,
        end: null,
      },
      cancelChange: false,
      min: minDate,
      max: maxDate,
      showEventCreationDialog: false,
      tasks: [],
      events: [["db_id", "Tenant", "Task", "Notes", "Hours", "Date & Time"]],
      tenants: [],
      show: false,
      title: "",
      tenant: "",
      task: "",
      range: "",
      date: "",
      lastSelectedTenant: "*",
      tenantsDropdown: [{name_first: "-SELECT ALL-", userID: "*", name_last: ""}],
    };
  },
  methods: {
    changeTitle() {
      this.selectedEvent.title = this.changeEvent.title;
    },
    onEventCreate(event, deleteEventFunction) {
      // console.log("onEventCreate called: ", deleteEventFunction);
      this.selectedEvent = event;
      this.deleteEventFunction = deleteEventFunction;
      event.deleteEventFunction = this.deleteEventFunction;

      return event;
    },
    onEventClick(event) {
      this.selectedEvent = {
        db_id: null,
        title: null,
        tenant: null,
        task: null,
      };
      event.deleteEventFunction();

      console.log("Event Selected", event);
      this.changeEvent.db_id = event.db_id;
      this.changeEvent.tenant = event.tenant;
      this.changeEvent.task = event.task;
      this.changeEvent.title = event.title;
      this.changeEvent.start = event.start;
      this.changeEvent.end = event.end;
      console.log("testing", this.changeEvent);
      this.handleTasks();

      this.$bvModal.show("changeModal");
      return event;
    },
    handleTasks() {
      console.log("handleTasks is running");
      this.tasks = [];
      this.selectedEvent.task = null;
      this.fetchTasks();
    },
    changeFormValidity() {
      console.log("checkFormValidity is running");
      const valid = this.$refs.changeForm.checkValidity();
      this.tenantState = valid;
      this.taskState = valid;
      this.noteState = valid;
      return valid;
    },
    checkFormValidity() {
      console.log("checkFormValidity is running");
      const valid = this.$refs.form.checkValidity();
      console.log(this.tenantState, this.taskState, this.noteState, this.selectedEvent.task);
      this.tenantState = valid;
      this.taskState = valid;
      this.noteState = valid;
      return valid;
    },
    changeModal() {
      this.cancelChange = true;
      this.createTask(this.changeEvent);
      this.changeEvent.tenant = "";
      this.changeEvent.task = "";
      this.changeEvent.title = null;
      this.changeEvent.start = null;
      this.changeEvent.end = null;

      this.tenantState = null;
      this.taskState = null;
      this.noteState = null;
    },
    resetModal() {
      // this.selectedEvent = null
      this.tasks = [];
      this.tenantState = null;
      this.taskState = null;
      this.noteState = null;
      this.deleteEventFunction();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    changeOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.changeSubmit();
    },
    handleSubmit() {
      console.log("handleSubmit is running");
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      //create event
      this.title = this.selectedEvent.title;
      this.task = this.selectedEvent.task;
      this.tenant = this.selectedEvent.tenant;
      this.createTask(this.selectedEvent);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("myModal");
      });
    },
    changeSubmit() {
      // Exit when the form isn't valid
      if (!this.changeFormValidity()) {
        return;
      }
      //create event
      this.title = this.changeEvent.title;
      this.task = this.changeEvent.task;
      this.tenant = this.changeEvent.tenant;

      this.patchTask(this.changeEvent);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("changeModal");
      });
    },
    onDateChange() {
      var fromDate = this.range.format("YYYY-MM-DD") + "T00:00:00.000Z"
      var toDate =  addDays(this.range, 6).format("YYYY-MM-DD") + "T00:00:00.000Z"
      if(fromDate != undefined && toDate != undefined) {
        this.fetchUsers();
      }
      if (this.lastSelectedTenant != "*") {
        this.fetchUserTasksBYUserIdAndDate(this.lastSelectedTenant, fromDate, toDate)
      }
    },
    generateCSV() {
      let events = this.events;
      events.forEach((el) => {
            if (el.length == 6) {
              el.shift()
          }
        });

      let csvContent =
          "data:text/csv;charset=utf-8," +
          events.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      window.open(encodedUri, "_self");
    },
    async fetchUserTasks() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const userTaskRequest = new Request(
          config.OPERATIONS_SERVICE + `/tenants/w/tasks?limit=100&offset=0`,
          {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          }
      );

      try {
        const taskResponse = await fetch(userTaskRequest);
        if (taskResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (taskResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          return;
        }
        if(taskResponse.status === 503) {
          return this.fetchUserTasks();
        }
        if (taskResponse.status != 200) {
          console.log(
              "Error occurred while fetching tasks: ",
              taskResponse.status
          );
          this.errorMessage = "Error occured while fetching tasks";
          this.tasks = ["NO TASKS DEFINED"];
        } else {
          const taskBody = await taskResponse.json();
          console.log("getUserTasks Response: ", taskBody.userTasks);

          taskBody.userTasks.forEach((el) => {
            this.createTask(el);
          });
        }
      } catch (tex) {
        console.log("Failed to get tasks:", tex);
        this.errorMessage = "Failed to get tasks due to an error.";
      }
    },

    async fetchUserTasksBYUserIdAndDate(userId, fromDate, toDate) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const userTaskRequest = new Request(
          config.OPERATIONS_SERVICE + `/tenants/w/tasks/${userId}/fromDate/${fromDate}/toDate/${toDate}?limit=100&offset=0`,
          {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          }
      );
      try {
        const taskResponse = await fetch(userTaskRequest);
        if (taskResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (taskResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          return;
        }
        if(taskResponse.status === 503) {
          return this.fetchUserTasksBYUserIdAndDate(userId, fromDate, toDate);
        }
        if (taskResponse.status != 200) {
          console.log(
              "Error occurred while fetching tasks: ",
              taskResponse.status
          );
          this.errorMessage = "Error occured while fetching tasks";
          this.tasks = ["NO TASKS DEFINED"];
        } else {
          const taskBody = await taskResponse.json();
          console.log("getUserTasks Response: ", taskBody.userTasks);

          this.events = [["db_id", "Tenant", "Task", "Notes", "Hours", "Date & Time"]];
          this.tasks = [];

          taskBody.userTasks.forEach((el) => {
            this.createTask(el);
          });
        }
      } catch (tex) {
        console.log("Failed to get tasks:", tex);
        this.errorMessage = "Failed to get tasks due to an error.";
      }
    },

    async changeEventDuration(event) {
      //PATCH event with changed time
      console.log(event);

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const postRequest = new Request(
          config.OPERATIONS_SERVICE + `/tenants/${event.event.tenant}/tasks/${event.event.db_id}`,
          {
            method: "PATCH",
            mode: "cors",
            body: JSON.stringify({
              task: `${event.event.task}`,
              notes: `${event.event.title}`,
              startDate: `${event.event.start}`,
              endDate: `${event.event.end}`,
            }),
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          }
      );

      try {
        const postResponse = await fetch(postRequest);

        if (postResponse.status != 200) {
          console.log(
              "Error occurred while posting task: ",
              postResponse.status
          );
          this.errorMessage = "Error occured while posting task";
        } else {
          const patchBody = await postResponse.json();
          console.log("this is post body", patchBody);
          console.log("posting event??", event);
        }
      } catch (tex) {
        console.log("Failed to post task:", tex);
        this.errorMessage = "Failed to post task due to an error.";
      }
      return;
    },
    async createTask(event) {
      if (this.cancelChange) {
        console.log("Editing Event Canceled");
        this.cancelChange = false;

        let interval = Math.abs(event.end - event.start);
        let minutes = Math.floor(interval / 1000 / 60);
        this.$refs.vuecal.createEvent(event.start, minutes, {
          title: event.title,
          db_id: event.db_id,
          tenant: event.tenant,
          task: event.task,
        });
        return;
      }
      if (event.endTimeMinutes) {
        //triggered when event is created on front end
        //POST event to db
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const postRequest = new Request(
            config.OPERATIONS_SERVICE + `/tenants/${event.tenant}/tasks`,
            {
              method: "POST",
              mode: "cors",
              body: JSON.stringify({
                task: `${event.task}`,
                notes: `${event.title}`,
                startDate: `${event.start}`,
                endDate: `${event.end}`,
              }),
              cache: "default",
              withCredentials: true,
              credentials: "include",
              headers: {
                Authorization: "Bearer " + id_token,
                "Content-Type": "application/json",
              },
            }
        );

        try {
          const postResponse = await fetch(postRequest);

          if (postResponse.status != 200) {
            console.log(
                "Error occurred while posting task: ",
                postResponse.status
            );
            this.errorMessage = "Error occured while posting task";
          } else {
            this.events.push([
              event.db_id,
              event.tenant,
              event.task,
              event.title,
              (event.endTimeMinutes - event.startTimeMinutes) / 60,
              event.start = new Date(event.start).format('MM/DD/YYYY HH:MM')
            ]);
            const postBody = await postResponse.json();
            this.$refs.vuecal.createEvent(
                event.start,
                event.endTimeMinutes - event.startTimeMinutes,
                {
                  title: this.title,
                  db_id: postBody.id,
                  tenant: this.tenant,
                  task: this.task,
                }
            );
            this.title = "";
          }
        } catch (tex) {
          console.log("Failed to post task:", tex);
          this.errorMessage = "Failed to post task due to an error.";
        }
        return;
      }
      this.title = event.notes;
      this.tenant = event.tenant;
      this.task = event.task_type;

      if (event.task_start_date_local) {
        //creating task from DB tasks
        let start = null;
        let end = null;
        let interval = null;
        let minutes = null;
        start = event.task_start_date_local.slice(0, -7);
        start = new Date(start);
        end = event.task_end_date_local.slice(0, -9);
        end = new Date(end);
        interval = Math.abs(end - start);
        minutes = Math.floor(interval / 1000 / 60);

        this.$refs.vuecal.createEvent(start, minutes, {
          title: event.notes,
          db_id: event.id,
          tenant: event.tenant,
          task: event.task_type,
        });
        this.events.push([
          event.id,
          event.tenant,
          event.task_type,
          event.notes,
          minutes / 60,
          event.start = new Date(event.task_start_date_local).format('MM/DD/YYYY HH:MM')
        ]);
        return;
      }
    },
    async patchTask(event) {
      //PATCH event with changed info
      let start = null;
      let end = null;
      let interval = null;
      let minutes = null;

      start = new Date(event.start);
      end = new Date(event.end);
      interval = Math.abs(end - start);
      minutes = Math.floor(interval / 1000 / 60);

      // this.$refs.vuecal.createEvent(start, minutes, {
      //   title: event.title,
      //   db_id: event.db_id,
      //   tenant: event.tenant,
      //   task: event.task,
      // });

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const postRequest = new Request(
          config.OPERATIONS_SERVICE + `/tenants/${event.tenant}/tasks/${event.db_id}`,
          {
            method: "PATCH",
            mode: "cors",
            body: JSON.stringify({
              task: `${event.task}`,
              notes: `${event.title}`,
              startDate: `${event.start}`,
              endDate: `${event.end}`,
            }),
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          }
      );

      try {
        const postResponse = await fetch(postRequest);

        if (postResponse.status != 200) {
          console.log(
              "Error occurred while posting task: ",
              postResponse.status
          );
          this.errorMessage = "Error occured while posting task";
        } else {
          const patchBody = await postResponse.json();
          console.log("editing event:", event);
        }
      } catch (tex) {
        console.log("Failed to post task:", tex);
        this.errorMessage = "Failed to post task due to an error.";
      }
      return;
    },
    async fetchTasks() {
      if (this.changeEvent.tenant) {
        this.tenant = this.changeEvent.tenant;
      } else {
        this.tenant = this.selectedEvent.tenant;
      }

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const tasks_request = new Request(
          config.OPERATIONS_SERVICE + `/tenants/${this.tenant}/available-tasks`,
          {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          }
      );
      try {
        const taskResponse = await fetch(tasks_request);
        if (taskResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (taskResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          return;
        }
        if(taskResponse.status === 503) {
          return this.fetchTasks();
        }
        if (taskResponse.status != 200) {
          console.log(
              "Error occurred while fetching tasks: ",
              taskResponse.status
          );
          this.errorMessage = "Error occured while fetching tasks";
          this.tasks = ["NO TASKS DEFINED"];
        } else {
          const taskBody = await taskResponse.json();
          this.tasks = taskBody.tasks;
        }
      } catch (tex) {
        console.log("Failed to get tasks:", tex);
        this.errorMessage = "Failed to get tasks due to an error.";
      }
    },
    async fetchData() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
          // PROD "https://tenant-service-dot-fifth-name-244415.ue.r.appspot.com/tenants/?list=true",
          config.TENET_SERVICE + "/tenants/?list=true",
          {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          }
      );
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";

          return;
        }
        if(tenantListResponse.status === 503) {
          return this.fetchData();
        }
        if (tenantListResponse.status != 200) {
          console.log(
              "Error occurred while fetching tenant list: ",
              tenantListResponse.status
          );
        } else {
          //console.log(tenantListResponse);
          var tenantsBody = await tenantListResponse.json();
          // console.log(tenantsBody);
          this.tenants = [...this.tenants, ...tenantsBody];
          this.tenants = this.tenants.sort(function (a, b) {
            if (!a.text) a.text = a.value
            var nameA = a.text.toUpperCase(); // ignore upper and lowercase
            if (!b.text) b.text = b.value
            var nameB = b.text.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            // names must be equal
            return 0;
          });
          this.tenants = [
            {text: "INTERNAL", value: "INTERNAL"},
            ...this.tenants,
          ];
          this.errorMessage = "";
        }
      } catch (tex) {
        console.log("Failed to get Tenant list:", tex);
        this.errorMessage = "Failed to get tenant list due to an error.";
      }
    },

    async fetchUsers() {
      var fromDate = this.range.format("YYYY-MM-DD") + "T00:00:00.000Z"
      var toDate =  addDays(this.range, 6).format("YYYY-MM-DD") + "T00:00:00.000Z"
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const userRequest = new Request(
          config.OPERATIONS_SERVICE + `/tenants/w/get-users/fromDate/${fromDate}/toDate/${toDate}`,
          {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          }
      );
      try {
        const userResponse = await fetch(userRequest);
        if (userResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (userResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          return;
        }
        if(userResponse.status === 503) {
          return this.fetchUsers();
        }
        if (userResponse.status != 200) {
          console.log(
              "Error occurred while fetching users: ",
              userResponse.status
          );
          this.errorMessage = "Error occured while fetching users";
        } else {
          const userBody = await userResponse.json();
          console.log("getUsers Response: ", userBody);
          this.tenantsDropdown = []
          this.tenantsDropdown.push({name_first: "-SELECT ALL-", userID: "*", name_last: ""})
          for (var i = 0; i < userBody.length; i++) {
            this.tenantsDropdown.push(userBody[i]._id)
          }
        }
      } catch (tex) {
        console.log("Failed to get users:", tex);
        this.errorMessage = "Failed to get users due to an error.";
      }
    },
    async showDateRangeAndUserDropdown() {
      if (this.$auth.isAuthenticated) {
        const claims = await this.$auth.getIdTokenClaims();
        const userPermissions = claims['https://care.ai/permissions'];
        if (userPermissions && userPermissions.length > 0 && userPermissions.indexOf('rpt:my-tsk') >= 0) {
          return true;
        }
        return false;
      }
      return false;
    }
  },
};
</script>


<style lang="scss" scoped>
.next-steps {
  .fa-link {
    margin-right: 5px;
  }
}

.cards-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: auto;
  grid-gap: 1rem;
}

.export-btn {
  float: right;
  background-color: #1A80A8;
}

.errorMessage {
  color: #f16161;
  // color: #1a80a8;
}

.card {
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  padding: 0.5rem;
  background-color: #5d6d7e;
  color: #fff;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
  color: red !important;
}

.bigtext {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #1a80a8;
}

.spacebelow {
  margin-bottom: 1.5rem;
  color: #6a6a6a;
}

.twocol-grids-container {
  display: grid;
  grid-template-columns: 80% 20%;
  grid-auto-rows: auto;
  grid-gap: 1rem;
}

.sub-cards-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: auto;
  grid-gap: 1rem;
  margin-top: 25px;
  margin-bottom: 100px;
}

.sub-card {
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  padding: 0.5rem;
  background-color: #3498db;
  color: #fff;
}

.sub-card-tn {
  font-size: 0.6rem !important;
  margin-bottom: 0px !important;
  text-transform: uppercase;
  text-align: center;
}

.sub-card-fn {
  font-size: 0.5rem !important;
  margin-bottom: 0px !important;
  text-transform: uppercase;
  text-align: center;
}

.sub-card-hd {
  font-size: 2rem !important;
  text-align: center;
}

.sub-card-r2 {
  vertical-align: middle;
  color: red;
  font-size: 0.6rem !important;
  text-align: right;
  position: relative;
  left: 79px;
  top: -46px;
  font-weight: bolder;
}

.sub-card-bottom {
  width: 100%;
}

.cal-container {
  height: 600px;
}

.vuecal__event {
  background-color: rgba(76, 172, 175, 0.35) !important;
}

.vuecal__event vuecal__event--focus {
  background-color: #0fa951;
}

.vuecal__event.leisure {
  background-color: rgba(253, 156, 66, 0.9);
  border: 1px solid rgb(233, 136, 46);
  color: #fff;
}

.vuecal__event.sport {
  background-color: rgba(255, 102, 102, 0.9);
  border: 1px solid rgb(235, 82, 82);
  color: #fff;
}

.modal-backdrop {
  z-index: 0;
}

.sub-card-r1 {
  color: #222;
  font-size: 0.6rem !important;
  text-align: left;
  font-weight: bolder;
  display: block;
  float: left;
}

.sub-card-r3 {
  font-size: 0.6rem !important;
  font-weight: bolder;
  display: block;
  float: right;
}

.sub-card-wrapper {
  border-bottom: 1px solid rgb(153, 153, 153);
  height: 60px !important;
  padding: 0px !important;
}

div.card > h4 {
  font-size: 2.5rem;
}

.sub-card-fn {
  font-size: 0.5rem;
  text-align: center;
  padding: 0px !important;
  margin: 0px !important;
}

table {
  border-collapse: collapse;
  border-left: 1px solid #999;
  border-right: 1px solid #999;
}

td,
th {
  border-bottom: 1px solid #999;
  padding: 0.5rem;
  text-align: left;
  font-size: 0.8em;
  vertical-align: text-top;
  word-break: break-all;
}

th {
  background-color: #199fff;
  color: #fff;
}

.subheading {
  width: 25%;
  background-color: #9994;
  border-right: 1px solid #999;
}

.darkMatter {
  font-weight: bolder;
}

.smallFont {
  font-size: 0.8em;
  display: block;
}

.isProcessing {
  background-color: #256db4 !important;
  color: #fff;
}

.isDone {
  background-color: #0fa951 !important;
  color: #fff;
}

.isErrored {
  background-color: #fe490f !important;
  color: #fff;
}

.tenantOption {
  color: #6a6a6a;
  padding: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.timesheet-body {
  padding: 20px !important;
}


</style>


